//  Overview.js
//
//  Updated 2/2.
//
//  Abstract: Overview dashboard functional component.

//  React
import React from 'react';
import clsx from 'clsx';

//  Components
import OverviewCard from './OverviewCard/OverviewCard.js';

//  Material-ui components
import {
    Typography,
    Container,
    Grid,
    makeStyles,
    Card,
    List,
    ListItem,
} from '@material-ui/core';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { LineChart, BarChart } from 'react-chartkick'
import 'chart.js'

//  CSS styles
const useStyles = makeStyles((theme) => ({
    root: {
    },
    // grid: {
    //     marginTop: '50px'
    // },
    heading: {
        // marginTop: '10vh',
        // marginBottom: 0
    },
    chart: {
        minWidth: '50%',
        maxWidth: '75%',
        justifyItems: 'center',
        justifySelf: 'center'
    }
}));

function createData(name, numberOfTests) {
    return { name, numberOfTests };
}

const rows = [
    createData('Tests starting this week', 85),
    createData('Tests in Progress', 23),
    createData('Tests Ready for Review Tests', 15),
];
export default function Overview(props) {

    const { overview } = props;


    const data = [
        { "name": "In Progress Tests", "data": { "2017-01-01": 5, "2017-01-05": 3, "2017-01-10": 10, "2017-01-12": 6, "2017-02-01": 2 } },
        { "name": "Delinquent Tests", "data": { "2017-01-01": 5, "2017-01-05": 3, "2017-01-10": 2, "2017-01-12": 6, "2017-02-01": 4 } },
        { "name": "Completed Tests", "data": { "2017-01-01": 5, "2017-01-05": 6, "2017-01-10": 10, "2017-01-12": 11, "2017-02-01": 13 } },
    ];


    //  CSS classes
    const classes = useStyles();

    //  Component rendering
    return (
        <>
            <Container>
                <Grid container spacing={3} direction='row' className={classes.grid}>
                    <Grid item>

                        <Typography variant="body2">
                            Overview Dr. Hall.
        </Typography>
                    </Grid>
                    <Grid item>
                        <Card variant="outlined">




                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Status</TableCell>
                                            <TableCell align="right">Number of Tests</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rows.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell component="th" scope="row">
                                                    {row.name}
                                                </TableCell>
                                                <TableCell align="right">{row.numberOfTests}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>

                    </Grid>

                    {/* <Grid item>
                        <OverviewCard cardTitle={'Create New Tests'} cardId={'create'} cardBody={`Create a new test or perform batch test creation here.`} />
                    </Grid>
                    <Grid item>
                        <OverviewCard cardTitle={'View In Progress Tests'} cardId={'view'} cardBody={`You have ${10} patient tests in progress. View or edit in-progress tests here.`} cardSubBody={`${1} test(s) have delinquent patient images.`} />
                    </Grid>
                    <Grid item>
                        <OverviewCard cardTitle={'Review Tests'} cardId={'review'} cardBody={`You have ${23} sets of patient test awaiting your review.`} />
                    </Grid> */}
                    <Grid item className={clsx(classes.chart)} >
                        <Card variant="outlined">

                            <LineChart data={data}
                                legend={true}
                                legend="bottom"
                                colors={["#97b4e8", "#808080", "#4984eb",]}
                                // colors={["#4984eb", "#97b4e8", "#e89e97", "#b6e897"]}
                                xtitle="Date"
                                ytitle="# of Tests"
                                thousands=","
                                messages={{ empty: "No data" }} />
                        </Card>

                    </Grid>
                    <Grid item className={clsx(classes.chart)} >
                        <Card variant="outlined">

                            <BarChart data={data}
                                legend={true}
                                legend="bottom"
                                colors={["#97b4e8", "#808080", "#4984eb",]}
                                // colors={["#4984eb", "#97b4e8", "#e89e97", "#b6e897"]}
                                xtitle="Date"
                                ytitle="# of Tests"
                                thousands=","
                                messages={{ empty: "No data" }} />
                        </Card>

                    </Grid>
                    <Grid item className={clsx(classes.chart)} >
                        <Card variant="outlined">

                            <LineChart data={data}
                                legend={true}
                                legend="bottom"
                                colors={["#97b4e8", "#808080", "#4984eb",]}
                                // colors={["#4984eb", "#97b4e8", "#e89e97", "#b6e897"]}
                                xtitle="Date"
                                ytitle="# of Tests"
                                thousands=","
                                messages={{ empty: "No data" }} />
                        </Card>

                    </Grid>
                    <Grid item>

                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

